import { AdminApiClient } from "../../api-client.js";
import { adminApiBaseUrl, adminApiPath, adminApiUrl } from "../../api/index.js";
import { createAdminAuthenticationApi, type AdminAuthenticationApi } from "./api.js";
import type { AdminSessionContext, AdminSessionResponse } from "./models.js";

export interface AdminAuthenticationService {
  loginUrl(): string;
  loadSession(): Promise<AdminSessionContext>;
  logout(): Promise<void>;
}

export function createAdminAuthenticationService(
  api: AdminAuthenticationApi = createAdminAuthenticationApi(defaultClient()),
): AdminAuthenticationService {
  return {
    loginUrl() {
      return adminApiUrl(adminApiPath("authLogin"));
    },
    async loadSession() {
      return normalizeSession(await api.getSession());
    },
    logout() {
      return api.logout();
    },
  };
}

function normalizeSession(response: AdminSessionResponse): AdminSessionContext {
  const user = response.user ?? {};
  return {
    environment: response.environment ?? "unknown",
    expiresAt: response.expiresAt,
    ...(response.csrfToken === undefined ? {} : { csrfToken: response.csrfToken }),
    user: {
      adminUserId: response.adminUserId ?? user.adminUserId ?? "admin",
      email: response.email ?? user.email ?? "admin@example.invalid",
      role: response.role ?? user.role ?? "READ_ONLY_ADMIN",
      permissions: response.permissions ?? user.permissions ?? [],
    },
  };
}

function defaultClient(): AdminApiClient {
  return new AdminApiClient({ baseUrl: adminApiBaseUrl() });
}
